<template>
    <div>
        <el-dialog
                append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                title="抢单"
                :visible.sync="dialogShow"
                width="50%"

                :modal-append-to-body="false">
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        抢 单
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                        <el-divider></el-divider>
                </template>
            <avue-form
                :option="option"
                v-model="form"
                v-if="dialogShow"
                @submit="formSubmit"
                id="grabSingle20211202"
                @error="formError">
                 <template slot="expectStartTime">
                     <el-input readonly v-model="orderRow.expectStartTime" placeholder="请输入内容"></el-input>
                 
                 </template>
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入 备注"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="scrapFormRemarkModel"></remarkModel>
                        </div>
                    </template>
                <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取 消</el-button>
                </template>
            </avue-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    grabSingleOption,
} from "./option.js";
import {
        getRemarkList,
        grabSingle,
 } from "@/api/gateservice/order/order-list/order-list";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
import {fieldDetail} from "@/api/v4ward/ordersetting/setting/selfForm"
export default {
    components:{
        remarkModel,vupload
    },
    data(){
        return{
            dialogFull:false,
            form:{

            },

            data:{},
            cheackedPeople:[],
            userList:[],
            groupList:[],
            dialogShow:false,
            option:grabSingleOption,
            orderId:'',
            orderRow:{},
        }
    },

    methods:{
        //获取字段填写修饰
        async getFieldDetail(projectId,moduleType,actionType){
            console.log("执行了")
            let obj = {
                projectId:projectId,
                moduleType:moduleType,
                actionType:actionType
            }
            let fieldObj
            fieldObj  = this.findObject(this.option.column,'remark')
            await fieldDetail(obj).then(res=>{
                let resField
                res.data.forEach(item=>{
                    if(item.fieldCode == "description"){
                        resField =item
                    }
                })
                if(resField){
                    if( resField.defaultMustFlag ==0){

                        fieldObj.rules[0].required=false
                        }else{
                            fieldObj.rules[0].required=true
                        }
                }



            })
        },
        openDialog(data){
            this.orderRow = data.orderRow;
            console.log("抢单的orderrow",this.orderRow)
            this.getFieldDetail(this.orderRow.projectId,this.orderRow.moduleType,2)

            this.dialogShow = true;
            this.orderId = data.orderId;
            this.form = {
                orderId:data.orderId,
                remark:'',
            }
            this.getGroupData();
        },

        closeDialog(){
            this.dialogShow = false;
        },
        formError(done){
            done()
        },

        formSubmit(form,done){


            grabSingle(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogVisible = false;
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})

                this.dialogShow = false;
                done()
            }).catch(err=>{


                done()
            })
        },
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {

                        self.dialogShow = false;

                })
                .catch(()=> {

                });
        },
        // 获取班组 以及班组成员
        async getGroupData(){

            // 获取备注模板
            await getRemarkList({orderId:this.orderId,actionType:2}).then(res=>{
                this.$refs.scrapFormRemarkModel.setRemarkList(res.data);
            })
        },


    }
}
</script>
